import { render } from "./EditOrganisationDailyReportSubHeaders.vue?vue&type=template&id=746f20ca"
import script from "./EditOrganisationDailyReportSubHeaders.vue?vue&type=script&lang=js"
export * from "./EditOrganisationDailyReportSubHeaders.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__